<template>
  <div id="app">
    <AppNavbar />
    <router-view />
    <AppFooter />
  </div>
</template>


<script>
import AppNavbar from "./components/Navbar.vue";
import AppFooter from "./components/Footer.vue";

import axios from 'axios'


//ONLINE
axios.post('https://incubator-cv.incubator-cv.com/', {
//LOCAL
//axios.post('http://localhost:8000/', {
  
  pagina: window.location.pathname
}).catch(() => {})
export default {
  components: {
    AppNavbar,
    AppFooter,
  },
};
</script>


